import React from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { Form, ImagePicker } from '.'
import accountService from '../../../features/account/service'
import { fetchAccount } from '../../../features/account/slice'
import { fetchIndividu } from '../../../features/individu/slice'
import { useViewport } from '../../../utils'
import adapter from '../../../features/account/adapter'
import { useInternationalization } from '../../../features/i18n'

const initialForm = {
  typeAccount: '',
  accountId: '',
  userId: '',
  name: '',
  status: 0,
  institution: '',
  content: '',
}

const ContentVerified = ({account}) => {
  const dispatch = useDispatch()
  const [form, setForm] = React.useState({})
  const { isMobile } = useViewport()
  const { translate } = useInternationalization()

  React.useEffect(() => {
    if(account){
      setForm({
        ...initialForm,
        ...adapter.accountToIndividuProfile(account, true)
      })
    }
  }, [account, setForm])

  const handleImage = (e) => {
    if(e){
      console.log(e)

      // setForm({...form, image: e})

      const formData = new FormData()
      formData.append('imgFotoProfile', e)

      const data = {
        userId: form.userId,
        formData
      }

      accountService.updateIndividuImage(data)
      .then(res => {
        console.log(res)
        toast.success('Sucessfully updated!')
        dispatch(fetchAccount())
        dispatch(fetchIndividu(form.userId))
      })
      .catch(err => {
        console.log(err)
        toast.error('Error.')
      })
    }
  }

  return (
    <div>
      <h1 className="hidden xl:block text-4xl font-bold font-primary mb-12">
        {translate('DASHBOARD', 'my_profile')}
      </h1>
      <div className="px-5 md:px-0 flex flex-wrap lg:flex-no-wrap lg:-mx-4 mb-8">
        <div className="w-1/2 lg:w-1/3 lg:px-4 mx-auto lg:mx-0">
          <div className="mx-auto lg:mx-0 my-8 lg:my-0" style={{maxWidth: '170px'}}>
            <ImagePicker
              defaultValue={form.image ? form.image : ''}
              onChange={handleImage}
            />
          </div>
        </div>
        <div className="lg:px-4 lg:ml-auto w-full lg:w-2/3" style={{paddingLeft: isMobile ? '' : ''}}>
          <Form form={form} setForm={setForm}/>
        </div>
      </div>
    </div>
  )
}

export { ContentVerified }
